export default "data:image/svg+xml,io.svg"